// Stage 200: pure finalTagOf — the settled-tag computation for a bite.
//
// Per Laughter-TINS.md §Trigger Condition, the LAST-WRITE-WINS swat tag
// for a bite is its "final" tag for laughter-recognition purposes. A
// bite never swatted has final tag IMPLICIT_REJECT.
//
// This is a pure function. It does NOT mutate inputs. It does NOT read
// from the live store directly — callers pass the snapshot they want
// resolved.

import type { Bite, SwatEntry } from '../../api/gadfly';

export type FinalTag = 'ACCEPT' | 'REJECT' | 'DEFER' | 'IMPLICIT_REJECT';

export function finalTagOf(
  bite: Bite,
  swats: ReadonlyArray<SwatEntry>,
): FinalTag {
  // Find the LAST swat targeting this bite index — useGadflyTurn's
  // applyGadflySwat already collapses duplicates (filter + append),
  // so the swat array is already last-write-wins, but we re-walk to
  // be defensive against a future store change.
  let chosen: SwatEntry | null = null;
  for (const e of swats) {
    if (e.biteIndex === bite.index) chosen = e;
  }
  if (!chosen) return 'IMPLICIT_REJECT';
  return chosen.tag;
}
